import { render, staticRenderFns } from "./modal_marcacao.vue?vue&type=template&id=10716603&scoped=true"
import script from "./modal_marcacao.vue?vue&type=script&lang=js"
export * from "./modal_marcacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10716603",
  null
  
)

export default component.exports